import { getFeature } from 'Cloud/Application/FeaturesEs6';
import type { EStorageType } from 'reactApp/modules/storage/storage.types';

export type CsatPlatform = 'desktop' | 'tablet' | 'phone';

export interface CsatSurvey {
    /**
     * Задержка показа опроса в миллисекундах с момента получения информации о том, что опрос активен
     * */
    delay: number;
    /**
     * Название фичи, при включении которой опрос будет считаться активным
     * */
    feature: string;
    /**
     * Доля пользователей, для которой активен опрос. Диапазон значений: [0, 1000]
     * */
    permille: number;
    /**
     * Задержка между показами в днях
     * */
    repeatAfterDays?: number;
    /**
     * Идентификатор опроса
     * */
    surveyId: string;
}

export interface CsatRawDetails {
    /**
     * Массив стораджей (идентификаторов страниц), на которых группа опросов может показываться
     */
    points: EStorageType[];
    /**
     * Массив платформ, на которых можно показывать опрос
     */
    platforms?: CsatPlatform[];
    /**
     * Настройки группы опросов
     */
    config: {
        /**
         * Массив опросов
         */
        feedbacks: CsatSurvey[];
    };
}

interface CsatLoggerOptions {
    consoleLog: boolean;
    logLevel: 'TRACE' | 'DEBUG' | 'INFO' | 'TIME' | 'WARN' | 'ERROR' | 'OFF';
}

export const DEFAULT_PLATFORMS: CsatPlatform[] = ['desktop', 'tablet'];

export const CSAT_SURVEYS_RAW: CsatRawDetails[] = getFeature('csat-survey-cloud');

export const CSAT_DOMAIN: string = getFeature('csat-domain') || 'e.mail.ru';

export const CSAT_FORCE_SHOW_SURVEY_ID: string | number | undefined = getFeature('csat-force-show-survey-id') || undefined;

export const CSAT_LOGGER_OPTIONS: CsatLoggerOptions = getFeature('csat-logger-options') || undefined;
